import React from 'react';

const SvgArrowLeft = props => (
  <svg width="1em" height="1em" viewBox="0 0 33 26" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      stroke={props.color}
      strokeWidth={3}
    >
      <path d="M13 1.686L2.393 12.293a1 1 0 000 1.414L13 24.314M4.896 13h23.27" />
    </g>
  </svg>
);

SvgArrowLeft.defaultProps = {
  color: '#1b1b1b',
};

export default SvgArrowLeft;
